import { useNavigate } from 'react-router-dom'

import { Alert, Box, Card, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { countryName } from 'modules/core/lib/countryList'
import i18n from 'modules/core/lib/i18n'
import legalEntities from 'modules/core/store/collections/legalEntities'

import { ChargebeeSubscriptionForm } from 'modules/billing/components/PaymentGateway/FullScreenStep/form'
import { FORBIDDEN_COUNTRIES } from 'modules/billing/components/PaymentGateway/FullScreenStep/helpers'
import FormBody from './_Body'

interface Props {
  form: ChargebeeSubscriptionForm
}

const BillingInfoSection = ({ form }: Props) => {
  const { navigation } = useNavigation()
  const navigate = useNavigate()
  const mainLegalEntity = legalEntities.main
  const isForbiddenCountry = FORBIDDEN_COUNTRIES.includes(
    mainLegalEntity?.attributes?.country.toLowerCase()
  )

  const ForbiddenCountryAlert = () => {
    return (
      <Box gap="s16">
        <Alert color="error">
          <Text.Normal color="radicalRed1500">
            {i18n.t('pricing_plans.billing_information.form.forbidden_country_message')}
          </Text.Normal>
        </Alert>
      </Box>
    )
  }

  return (
    <Box gap="s16">
      <Text.Header2 weight="semibold">
        {i18n.t('pricing_plans.billing_information.form.billing_title')}
      </Text.Header2>
      <Card>
        <Card.Content>
          <Box alignItems="center" flexDirection="row" justifyContent="spaceBetween" width="full">
            <Text.Normal weight="medium" color="grey1000">
              {countryName(mainLegalEntity?.attributes?.country)}
            </Text.Normal>
            <Box
              cursor="pointer"
              onClick={() =>
                navigate(navigation.settings.legalEntitiesId.fullPath({ id: mainLegalEntity?.id }))
              }
            >
              <Text.Normal size="200" color="viridian1200">
                {i18n.t('pricing_plans.billing_information.form.change_country')}
              </Text.Normal>
            </Box>
          </Box>
        </Card.Content>
      </Card>
      {isForbiddenCountry ? (
        <ForbiddenCountryAlert />
      ) : (
        <FormBody form={form} country={mainLegalEntity?.attributes?.country} />
      )}
    </Box>
  )
}

export default observer(BillingInfoSection)
